import type { ExtensionProvider, UpdateExtension } from '@atlaskit/editor-common/extensions';
import { getExtensionModuleNode } from '@atlaskit/editor-common/extensions';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import { updateState } from '../editor-commands/commands';
import { getSelectedExtension } from './utils';

const maybeGetExtensionModuleNode = async (
	view: EditorView,
	extensionProvider: ExtensionProvider,
) => {
	const nodeWithPos = getSelectedExtension(view.state, true);
	if (!nodeWithPos) {
		throw new Error('There is no selection');
	}

	const { extensionType, extensionKey } = nodeWithPos.node.attrs;

	const extensionModuleNode = await getExtensionModuleNode(
		extensionProvider,
		extensionType,
		extensionKey,
	);

	const newNodeWithPos = getSelectedExtension(view.state, true);

	if (
		newNodeWithPos &&
		newNodeWithPos.node.attrs.extensionType === extensionType &&
		newNodeWithPos.node.attrs.extensionKey === extensionKey &&
		newNodeWithPos.pos === nodeWithPos.pos &&
		extensionModuleNode
	) {
		return extensionModuleNode;
	}
};

export const updateEditButton = async (
	view: EditorView,
	extensionProvider: ExtensionProvider,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<UpdateExtension<any> | undefined> => {
	try {
		const extensionModuleNode = await maybeGetExtensionModuleNode(view, extensionProvider);
		const updateMethod = extensionModuleNode?.update;

		updateState({
			showEditButton: !!updateMethod,
			showCopyButton: !extensionModuleNode?.hideCopyButton,
			updateExtension: (updateMethod && Promise.resolve(updateMethod)) || undefined,
		})(view.state, view.dispatch);

		return updateMethod;
	} catch {
		// this exception is not important for this case, fail silently
	}
};
